import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { apiClient } from '@api/client';
import { useNotificationStore } from '@store/notificationStore';
import type { OnboardingConfigResponse } from './useOnboarding';

export const useUpdateFieldConfig = () => {
  const queryClient = useQueryClient();
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: async (config: {
      extraction_fields: {
        purchase_order: string[];
        receipt: string[];
        invoice: string[];
      };
      vendor_fields: string[];
      bill_creation_fields: string[];
    }) => {
      const { data } = await apiClient.patch<OnboardingConfigResponse>(
        'users/onboarding/config',
        config
      );
      return data;
    },
    onSuccess: () => {
      addNotification({
        message: 'Field configuration updated successfully',
        type: 'success',
      });
      queryClient.invalidateQueries({ queryKey: ['onboarding-config'] });
    },
    onError: (error: AxiosError<{ detail?: string }>) => {
      addNotification({
        message: error.response?.data?.detail || 'Failed to update field configuration',
        type: 'error',
      });
    },
  });
};
